export default __webpack_public_path__ + "static/media/icon-ui-campaign.943f41a5.svg";